package pro.jayeshseth.animations.itemPlacements.screens.listItemPlacements

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.Easing
import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.spring
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.animation.togetherWith
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.rounded.Link
import androidx.compose.material.icons.rounded.Settings
import androidx.compose.material3.CenterAlignedTopAppBar
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.material3.rememberTopAppBarState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.BlurEffect
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.TileMode
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.nestedscroll.nestedScroll
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import dev.chrisbanes.haze.HazeState
import kotlinx.coroutines.delay
import pro.jayeshseth.animations.core.model.AnimationControllerState
import pro.jayeshseth.animations.core.model.DampingRatioList
import pro.jayeshseth.animations.core.model.EasingList
import pro.jayeshseth.animations.core.model.OnClickLink
import pro.jayeshseth.animations.core.model.StiffnessList
import pro.jayeshseth.animations.core.ui.components.Toggler
import pro.jayeshseth.animations.itemPlacements.components.AnimationController
import pro.jayeshseth.animations.itemPlacements.components.AnimationItem
import pro.jayeshseth.animations.itemPlacements.utils.BASE_FEATURE_ROUTE

/**
 * Scale item placement animation by scaling X and Y position of the item
 */
@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ScaleItemPlacement(
    hazeState: HazeState,
    onClickLink: OnClickLink,
    modifier: Modifier = Modifier
) {
    var isVisible by remember { mutableStateOf(false) }
    val scrollBehavior =
        TopAppBarDefaults.exitUntilCollapsedScrollBehavior(rememberTopAppBarState())
    val scaleX = remember { mutableStateOf(true) }
    val scaleY = remember { mutableStateOf(false) }
    val easingList = remember { EasingList }
    val selectedEasing by remember { mutableStateOf(easingList[0]) }
    val dampingRatioList = remember { DampingRatioList }
    val selectedDampingRatio by remember { mutableStateOf(dampingRatioList[0]) }
    val stiffnessList = remember { StiffnessList }
    val selectedStiffness by remember { mutableStateOf(stiffnessList[0]) }
    val lazyListState = rememberLazyListState()
//    val context = LocalContext.current

    val state = remember {
        mutableStateOf(
            AnimationControllerState(
                vibrationEffect = true,
                showShadow = false,
                shepardTone = false,
                initialValue = 0.5f,
                initialValueRange = -5f..5f,
                initialValueSteps = 0,
                tweenDuration = 300,
                selectedIndex = 0,
                easingList = easingList,
                easing = selectedEasing,
                dampingRatioList = dampingRatioList,
                dampingRatio = selectedDampingRatio,
                stiffnessList = stiffnessList,
                stiffness = selectedStiffness,
                blurValueSteps = 0,
                blurValue = 200f,
                blurValueRange = 0f..500f,
                blurEffect = true,
                delay = 0
            )
        )
    }

//    if (state.value.shepardTone) {
//        LaunchedEffect(lazyListState.isScrollInProgress) {
//            if (lazyListState.isScrollInProgress) {
//                AudioPlayer.play(context, AnimMedia.windChimes)
//            } else {
//                AudioPlayer.stop()
//            }
//        }
//    }
//
//    DisposableEffect(Unit) {
//        onDispose {
//            AudioPlayer.stop()
//        }
//    }

    Scaffold(
        modifier = modifier,
        containerColor = Color.Transparent,
        topBar = {
            CenterAlignedTopAppBar(
                scrollBehavior = scrollBehavior,
                colors = TopAppBarDefaults.topAppBarColors(
                    containerColor = Color.Transparent,
                    scrolledContainerColor = Color.Transparent,
                ),
                title = {
                    AnimatedContent(
                        targetState = isVisible,
                        transitionSpec = {
                            if (targetState > initialState) {
                                slideInVertically(animationSpec = tween(easing = LinearEasing)) { -it } + fadeIn(
                                    animationSpec = tween(easing = LinearEasing)
                                ) togetherWith slideOutVertically { it } + fadeOut(
                                    animationSpec = tween(easing = LinearEasing)
                                )
                            } else {
                                slideInVertically(animationSpec = tween(easing = LinearEasing)) { it } + fadeIn(
                                    animationSpec = tween(easing = LinearEasing)
                                ) togetherWith slideOutVertically(animationSpec = tween(easing = LinearEasing)) { -it } + fadeOut(
                                    animationSpec = tween(easing = LinearEasing)
                                )
                            }
                        },
                        label = "title transitions animation"
                    ) {
                        Text(
                            if (it) {
                                "Animation Controller"
                            } else {
                                "Scale"
                            },
                            modifier = Modifier.fillMaxWidth(),
                            textAlign = TextAlign.Center
                        )
                    }
                },
                navigationIcon = {
                    IconButton(onClick = {
                        onClickLink("${BASE_FEATURE_ROUTE}/screens/listItemPlacements/ScaleItemPlacement.kt")
                    }) {
                        Icon(imageVector = Icons.Rounded.Link, contentDescription = null)
                    }
                },
                actions = {
                    IconButton(onClick = { isVisible = !isVisible }) {
                        Icon(imageVector = Icons.Rounded.Settings, contentDescription = null)
                    }
                },
            )
        }
    ) {
        LazyColumn(
            state = lazyListState,
            modifier = Modifier
                .nestedScroll(scrollBehavior.nestedScrollConnection)
        ) {
            item {
                Spacer(modifier = Modifier.padding(top = it.calculateTopPadding()))
            }
            item {
                AnimatedVisibility(
                    isVisible,
                    enter = slideInVertically(tween(500)),
                    exit = slideOutVertically(tween(500)),
                ) {
                    ScaleAnimationController(
                        hazeState = hazeState,
                        state = state.value,
                        onStateUpdate = { state.value = it },
                        scaleX = scaleX.value,
                        onScaleXChanged = { scaleX.value = it },
                        scaleY = scaleY.value,
                        onScaleYChanged = { scaleY.value = it },
                    )
                }
            }
            items(100000) {
                ScaleListItem(
                    index = it,
                    isScaleX = scaleX.value,
                    isScaleY = scaleY.value,
                    isVibration = state.value.vibrationEffect,
                    initialValue = state.value.initialValue,
                    tweenDuration = state.value.tweenDuration,
                    showShadow = state.value.showShadow,
                    easing = state.value.easing.easing,
                    isTween = state.value.selectedIndex == 0,
                    stiffness = state.value.stiffness.stiffness,
                    dampingRatio = state.value.dampingRatio.dampingRatio,
                    blurValue = state.value.blurValue,
                    doBlur = state.value.blurEffect,
                    delay = state.value.delay
                )
            }
        }
    }
}

@Composable
private fun ScaleAnimationController(
    hazeState: HazeState,
    state: AnimationControllerState,
    onStateUpdate: (AnimationControllerState) -> Unit,
    scaleX: Boolean,
    onScaleXChanged: (Boolean) -> Unit,
    scaleY: Boolean,
    onScaleYChanged: (Boolean) -> Unit,
    modifier: Modifier = Modifier
) {
    AnimationController(
        state = state,
        hazeState = hazeState,
        onStateUpdate = onStateUpdate,
        modifier = modifier,
        roundToInt = false,
        content = {
            Column {
                Row(
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Toggler(
                        title = "Scale X",
                        hazeState = hazeState,
                        checked = scaleX,
                        onCheckedChanged = onScaleXChanged
                    )
                    Toggler(
                        title = "Scale Y",
                        hazeState = hazeState,
                        checked = scaleY,
                        onCheckedChanged = onScaleYChanged
                    )
                }
            }
        },
    )
}

@Composable
private fun ScaleListItem(
    index: Int,
    initialValue: Float,
    doBlur: Boolean,
    blurValue: Float,
    isScaleX: Boolean,
    isScaleY: Boolean,
    showShadow: Boolean,
    isTween: Boolean,
    isVibration: Boolean,
    tweenDuration: Int,
    easing: Easing,
    dampingRatio: Float,
    stiffness: Float,
    delay: Long,
    modifier: Modifier = Modifier,
    isDarkMode: Boolean = isSystemInDarkTheme()
) {
//    val context = LocalContext.current
    val animatedProgress = remember { Animatable(initialValue) }
    val animatedBlur = remember { Animatable(blurValue) }
//    val vibrator = ContextCompat.getSystemService(context, Vibrator::class.java)
    val shadowColor = MaterialTheme.colorScheme.primary

    LaunchedEffect(index) {
//        if (isVibration) {
//            if (Build.VERSION.SDK_INT >= Build.VERSION_CODES.Q) {
//                vibrator!!.vibrate(VibrationEffect.createPredefined(VibrationEffect.EFFECT_TICK))
//            }
//        }
        if (isTween) {
            delay(delay)
            animatedProgress.animateTo(
                targetValue = 1f,
                animationSpec = tween(tweenDuration, easing = easing)
            )
        } else {
            delay(delay)
            animatedProgress.animateTo(
                targetValue = 1f,
                animationSpec = spring(
                    dampingRatio = dampingRatio,
                    stiffness = stiffness,
                )
            )
        }
    }
    LaunchedEffect(index) {
        if (doBlur && isTween) {
            delay(delay)
            animatedBlur.animateTo(
                targetValue = 0f,
                animationSpec = tween(tweenDuration, easing = easing)
            )
        } else {
            delay(delay)
            animatedBlur.animateTo(
                targetValue = 0f,
                animationSpec = spring(
                    dampingRatio = dampingRatio,
                    stiffness = stiffness,
                )
            )
        }

    }
    AnimationItem(
        modifier = modifier
            .padding(8.dp)
            .graphicsLayer {
                shape = RoundedCornerShape(12.dp)
                if (showShadow) shadowElevation = animatedProgress.value
                if (showShadow && isDarkMode) spotShadowColor = shadowColor
                if (showShadow && isDarkMode) ambientShadowColor = shadowColor
                if (isScaleX) scaleX = animatedProgress.value
                if (isScaleY) scaleY = animatedProgress.value
                if (doBlur && animatedBlur.value > 0f) {
                    renderEffect = BlurEffect(
                        animatedBlur.value,
                        animatedBlur.value,
                        TileMode.Decal
                    )
                }
            }
    )
}